import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedModule} from '../../../../core/modules/shared.module';
import {AddUserDialogComponent} from './add.user.dialog.component';

const routes = [{path: 'userdialog', component: AddUserDialogComponent}];

@NgModule({
  declarations: [AddUserDialogComponent],
  imports: [SharedModule, RouterModule.forChild(routes)],
  exports: [AddUserDialogComponent]
})

export class AddUserModule {}


// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/users/add/add.user.dialog.module.ts